import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListSubheader from '@mui/material/ListSubheader';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { groupHeaderStyles as sx } from './GroupHeader.styles';

type Props = {
	title: string;
	loading?: boolean;
	onClear?: () => void;
};

export const GroupHeader = ({ title, onClear }: Props) => {
	const { t } = useTranslation();

	return (
		<ListSubheader sx={sx.root}>
			<Box sx={sx.titleContainer}>
				<Typography variant='subtitle2'>{title}</Typography>
			</Box>

			{onClear && (
				<Button sx={sx.clearButton} onClick={onClear}>
					{t('Clear')}
				</Button>
			)}
		</ListSubheader>
	);
};
